import { useState } from 'react';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handlePortalClick = () => {
    window.REACT_APP_NAVIGATE('/login');
    setMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
        scrolled ? 'shadow-md' : 'shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/15bc058aae6871dddacc3df221856caf/d4d36b6f86ae117e8d157e4db0d4a7dd.png"
              alt="Inter-American Procurement Group"
              className="h-16 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-orange-600"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-orange-600"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('industries')}
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-orange-600"
            >
              Industries
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-orange-600"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('case-studies')}
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-orange-600"
            >
              Case Studies
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-orange-600"
            >
              Contact
            </button>
            <button
              onClick={handlePortalClick}
              className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-orange-600"
            >
              Client Portal
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-orange-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-700 transition-colors whitespace-nowrap"
            >
              Get Quote
            </button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-600 py-2 whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-600 py-2 whitespace-nowrap"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('industries')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-600 py-2 whitespace-nowrap"
            >
              Industries
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-600 py-2 whitespace-nowrap"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('case-studies')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-600 py-2 whitespace-nowrap"
            >
              Case Studies
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-600 py-2 whitespace-nowrap"
            >
              Contact
            </button>
            <button
              onClick={handlePortalClick}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-600 py-2 whitespace-nowrap"
            >
              Client Portal
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-orange-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-700 transition-colors whitespace-nowrap"
            >
              Get Quote
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}